var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.787,
    height: 19.874,
    viewBox: "0 0 22.787 19.874",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6282",
    "data-name": "Group 6282",
    transform: "translate(-242 -4260)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_36",
    "data-name": "Union 36",
    d: "M15740.832,13592.874a.784.784,0,0,1-.708-.407.736.736,0,0,1,0-.819l10.563-18.24a.819.819,0,0,1,1.416,0l10.563,18.24a.751.751,0,0,1,0,.819.789.789,0,0,1-.708.407Z",
    transform: "translate(-15498 -9313)",
    fill: "#ea3943"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6281",
    "data-name": "Group 6281",
    transform: "translate(-78.342 -4.399)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "warning_FILL0_wght400_GRAD0_opsz48",
    d: "M23.493,22.368Zm.088-2.968a.854.854,0,0,0-.882.882V25.1a.882.882,0,1,0,1.763,0v-4.82a.854.854,0,0,0-.882-.882Zm0,9.845A.854.854,0,1,0,22.95,29,.856.856,0,0,0,23.582,29.245Z",
    transform: "translate(308.153 4252)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "warning_FILL0_wght400_GRAD0_opsz48-2",
    "data-name": "warning_FILL0_wght400_GRAD0_opsz48",
    d: "M23.493,22.368Zm.088-2.968a.854.854,0,0,0-.882.882V25.1a.882.882,0,1,0,1.763,0v-4.82a.854.854,0,0,0-.882-.882Zm0,9.845A.854.854,0,1,0,22.95,29,.856.856,0,0,0,23.582,29.245Z",
    transform: "translate(308.153 4252)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedWarning);
export default __webpack_public_path__ + "static/media/red_warning.310549600251d3fe17d61617fe76ad22.svg";
export { ForwardRef as ReactComponent };